var blogArticleAjax = false;

var initializeBlogArticlesBlock = function(block){
    
    jQuery('#load-more', block).on('click', function(){
		
		var blogArticlesContainer = jQuery(this).parent().prev();
		var count = blogArticlesContainer.data('count');
		var loadMoreCount = parseInt(blogArticlesContainer.attr('data-load-more'));
		var content = blogArticlesContainer.attr('data-content');
		var type = jQuery('#' + content + '-type').val();
		var topic = jQuery('#' + content + '-topic').val();
		var offset = count + (count*loadMoreCount);
		
		jQuery(this).addClass('ajax-loader');
		
		get_blog_articles(blogArticlesContainer, content, offset, type, topic, '');
		
		loadMoreCount++;
		blogArticlesContainer.attr('data-load-more', loadMoreCount);
		
	});
	
	jQuery('.archive-filter', block).on('change', function(){
		
		var blogArticlesContainer = jQuery(this).parents('.archive-filters').next();
		var content = blogArticlesContainer.attr('data-content');
		var type = jQuery('#' + content + '-type').val();
		var topic = jQuery('#' + content + '-topic').val();
		var offset = 0;
		
		jQuery('#' + content + '-search input').val('');
		
		jQuery(this).addClass('ajax-loader');
		
		get_blog_articles(blogArticlesContainer, content, offset, type, topic);
		
		blogArticlesContainer.attr('data-load-more', 0);
		
	});
	
	jQuery('.filter-search', block).on('submit', function(e){
		
		e.preventDefault();
		
		var blogArticlesContainer = jQuery(this).parents('.archive-filters').next();
		var content = blogArticlesContainer.attr('data-content');
		var type = false;
		var topic = false;
		var offset = 0;
		var search = jQuery('#' + content + '-search input').val();
		
		jQuery('#' + content + '-type').val('');
		jQuery('#' + content + '-topic').val('');
		
		get_blog_articles(blogArticlesContainer, content, offset, type, topic, search);
		
		blogArticlesContainer.attr('data-load-more', 0);
		
	});
    
}

function get_blog_articles(blogArticlesContainer, content, offset = 0, type = false, topic = false, search = ''){
	
	if(blogArticleAjax)
		return false;
	
	blogArticleAjax = blogArticlesContainer.each(function(){
		
		var articleContainer = jQuery(this);
		var count = search ? 50 : articleContainer.attr('data-count');
		
		jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=get_blog_articles&content=' + content + '&type=' + type + '&topic=' + topic + '&offset=' + offset + '&count=' + count + '&search=' + search,
			success:function(results){
				
				if(offset){
					
					if(results) {
						articleContainer.append(results);
					}
					
				}else{
					
					articleContainer.html(results);
					
				}
				
				jQuery('.load-more').removeClass('ajax-loader');
				blogArticleAjax = false;
				
			}
		});			
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-blog-articles').each(function(){
        initializeBlogArticlesBlock(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=blog-articles', initializeBlogArticlesBlock);
